import { PreguntaExportador } from "../PreguntaExportador";
import { FilasExcel, MultipleSubtipoEnum, PreguntasTipoEnum } from "@shared/enums";
import { PreguntaDTO } from "@DTOS";
import { DatosEncuestaExportar } from "../DatosEncuestaExportar";

export class PreguntaMultipleExportador extends PreguntaExportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.MULTIPLE_CHOICE;
    }

    protected generarFilaPregunta(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string> {
        const preguntaCambio = new PreguntaDTO(datosEncuesta.pregunta.toJSON());
        switch (preguntaCambio.subtipo) {
        case MultipleSubtipoEnum.REGULAR:
            break;
        case MultipleSubtipoEnum.YESNO:
            preguntaCambio.tipo = PreguntasTipoEnum.SIYNO;
            break;
        }
        const fila = super.generarFilaPregunta({
            ...datosEncuesta,
            pregunta: preguntaCambio
        });
        if (fila.get(FilasExcel.MIN_MAX) == null || fila.get(FilasExcel.MIN_MAX) === "") {
            fila.set(FilasExcel.MIN_MAX, "1;0");
        }
        if (!fila.get(FilasExcel.MIN_MAX)!.includes(";")) {
            fila.set(FilasExcel.MIN_MAX, `${fila.get(FilasExcel.MIN_MAX)!};0`);
        }
        return fila;
    }

    protected generarItemsPregunta(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string>[] {
        const filasItems = super.generarItemsPregunta(datosEncuesta);
        filasItems.forEach(filaItem => {
            filaItem.set(FilasExcel.MIN_MAX, "");
        });
        return filasItems;
    }
}
